import { CANARY_MISSION } from "@/enum/enum"
export type SpecialLayoutObject = {
    type?: string,
    title?: string,
    iframeSrc?: string,
    coverImage?: string,
    iframeType?: 'Image' | 'Video',
    link?: string,
    linkToShare?: string,
    sectionTitle?: string,
    sectionText?: string,
    backgroundColor?: string,
    darkBackgroundColor?: string,
}

export const CanadaData: SpecialLayoutObject = {
    type: 'canada',
    title: 'Canada',
    iframeSrc: 'https://cmcdn.canarymission.org/api/media/file/UofT.Final.Final.mp4',
    coverImage: 'https://cmcdn.canarymission.org/api/media/file/U%20of%20T%20Thumb%20NEW-800x450.webp',
    iframeType: 'Video',
    link: 'https://canarymission.org/campaign/U_Of_Torontos_Encampment',
    linkToShare: 'https://canarymission.org/campaign/U_Of_Torontos_Encampment',
    sectionTitle: 'University of Toronto’s Encampment',
    sectionText: 'The University of Toronto administration, including President Meric Gertler, knowingly allowed Jewish and pro-Israel students, faculty and staff to face harassment, intimidation, and verbal and physical abuse from encampment participants.'
}

export const MedicalData: SpecialLayoutObject = {
    type: 'medical',
    title: 'Medical Professionals',
    iframeSrc: 'https://cmcdn.canarymission.org/api/media/file/Canary%20Mission%20EXPOSES%20Another%20Anti-Semitic%20Doctor!.mp4',
    coverImage: 'https://cmcdn.canarymission.org/api/media/file/medicalCoverImage-800x450.webp',
    iframeType: 'Video',
    link: 'https://canarymission.org/individual/Walid_Khass',
    linkToShare: 'https://youtu.be/b6MBirpnlUQ?feature=shared',
    sectionTitle: `${CANARY_MISSION.NAME} EXPOSES Another Anti-Semitic Doctor!`,
    sectionText: `Walid Khass made numerous threatening anti-Semitic remarks on social media while pre-med and during medical school. In March 2019, Dr. Khass matched as a pediatric resident at NYP Brooklyn hospital. After discovering his hateful posts they removed him from the position, citing significant risk to their "large Jewish population." Dr. Khass successfully sued the hospital, forcing them to reinstate him.`,
}